module.exports = __webpack_public_path__ + "img/ojon_i_sol.6c9afb45.jpg";